import { SectionTagCsx } from '@components/common'
import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'stretch',
    flexDirection: { xs: 'column-reverse', md: 'row' },
    gap: '16px',
    backgroundColor: 'transparent',
    padding: { md: ' 32px 0px' },
    borderRadius: '16px',
    justifyContent: 'space-between',
    zIndex: 10,
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexBasis: { xs: 'unset', md: '60%' },
    gap: '16px',
    '& a': {
      color: 'text.secondaryDark',
    },
  },
  document: {
    '& p': { color: 'text.secondaryDark' },
    '& li': {
      color: 'text.secondaryDark',
      padding: '8px 0px',
    },
    '& ul': {
      margin: 'unset',
    },
  },
  image: {
    borderRadius: '16px',
    height: {
      xs: '330px',
      md: 'auto',
    },
    width: {
      xs: '100%',
      md: '408px',
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    '& img': {
      objectFit: 'cover',
      width: '100%',
      height: '100%',
    },
  },
  descriptionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: {
      xs: '16px',
      md: '20px',
    },
  },
})

export const sectionTagCsx: SectionTagCsx = {
  disc: {
    backgroundColor: 'grey.600',
  },
  wrapper: {
    backgroundColor: 'background.paper',
    color: 'grey.600',
  },
  label: {
    color: 'grey.600',
  },
}

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
